import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";

import PointsOfInterest from "./PointsofInterest";

import Cover from "../components/Cover";
import Headline from "../components/Headline";
import LimitedTrackTips from "../components/LimitedTrackTips";
import NumberedList from "../components/NumberedList";
import SectionHeading from "../components/SectionHeading";
import TrackCard from "../components/TrackCard";
import TrackMap from "../components/TrackMap";
import TrackTips from "../components/TrackTips";
import TurnCarousel from "../components/TurnCarousel";
import VideoPlaceholder from "../components/VideoPlaceholder";
import VideoPlayer from "../components/VideoPlayer";
import VideoWrapper from "../components/VideoWrapper";

import GlobalStyle from "../theme/GlobalStyle";

const Content = styled.div`
	margin: auto;
	max-width: 924px;
`;

const MapBackground = styled.div`
	padding: 60px 0;
	background-color: #012126;
`;

const FlexWrapper = styled.div`
	display: flex;
	margin: 40px 0;

	@media (max-width: 576px) {
		flex-direction: column;
		padding: 10px;

		& > :first-child {
			margin-bottom: 40px;
		}
	}

	@media (min-width: 577px) {
		& > :first-child {
			margin-right: 30px;
		}
	}

	& :first-child {
		flex: 2;
	}

	& :last-child {
		flex: 1;
	}
`;

const getKey = () => {
	const params = new URLSearchParams(window.location.search);
	return params.get("key");
};

const TrackGuide = ({ guideId }) => {
	const [data, setData] = useState(null);
	const [currentTurn, setCurrentTurn] = useState(null);

	useEffect(() => {
		fetch(`/api/v2/track_guides/${guideId}?key=${getKey()}`)
			.then((res) => res.json())
			.then((res) => {
				setData(res);
				setCurrentTurn(res.turns[0]?.number);
			});
	}, [guideId]);

	if (!data) return <h1>Loading...</h1>;

	const isPremium = data.view == "premium";
	const hasTurns = data.turns.length > 0;
	const hasPointsOfInterest = !!(
		data.restaurants.length ||
		data.lodgings.length ||
		data.attractions.length
	);

	return (
		<div className="trackguide">
			<GlobalStyle />
			<Cover image={data.image_url} />
			<Content>
				<Headline title={data.track.name} text={data.headline} />

				<SectionHeading>Things to Know</SectionHeading>
				<NumberedList>{[data.tip_1, data.tip_2, data.tip_3]}</NumberedList>

				{data.has_video && (
					<Fragment>
						<SectionHeading>
							{data.headline_video_title || "Video Overview"}
						</SectionHeading>
						<VideoWrapper>
							{isPremium ? (
								<VideoPlayer videoId={data.video_id} />
							) : (
								<VideoPlaceholder />
							)}
						</VideoWrapper>
					</Fragment>
				)}
			</Content>

			<MapBackground hasVideo={data.has_video}>
				<Content>
					<SectionHeading>Track Map & Pro Tips</SectionHeading>
					{data.map_url && (
						<TrackMap
							svgUrl={data.map_url}
							currentTurn={currentTurn}
							onTurnChange={(turn) => setCurrentTurn(turn)}
						/>
					)}
					{isPremium && hasTurns && (
						<TurnCarousel
							turns={data.turns}
							currentTurn={currentTurn}
							onTurnChange={(turn) => setCurrentTurn(turn)}
						/>
					)}
				</Content>
			</MapBackground>

			<Content>
				<FlexWrapper>
					{isPremium ? (
						<TrackTips turns={data.turns} />
					) : (
						<LimitedTrackTips turns={data.turns} />
					)}
					<TrackCard {...data} />
				</FlexWrapper>

				{hasPointsOfInterest && (
					<Fragment>
						<SectionHeading>Eat/Stay/Do</SectionHeading>
						<PointsOfInterest {...data} />
					</Fragment>
				)}
			</Content>
		</div>
	);
};

export default TrackGuide;
